import script from "./Providers.vue?vue&type=script&setup=true&lang=js"
export * from "./Providers.vue?vue&type=script&setup=true&lang=js"

import "./Providers.vue?vue&type=style&index=0&id=39fe7e8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39fe7e8a"]])

export default __exports__